/**
 * Pricing cards on the "Tarieven" section.
 */
export const pricingItems = [
  {
    title: 'Individuele therapiesessie',
    price: '€ 95',
    unit: 'per 50 minuten',
    body: 'Inclusief administratiekosten en verslaglegging. Voor een eerste EMDR-sessie is een dubbele sessie wenselijk.',
    featured: true,
  },
  {
    title: 'Inventarisatiegesprek',
    price: '€ 75',
    unit: 'per uur',
    body: 'Begeleiding bij het vinden van de juiste psychologische zorg, met gebruik van mijn netwerk en kennis van het GGZ-systeem.',
  },
];
